/**
 * Labstep
 *
 * @module prosemirror/components/NodeView/Molecule
 * @desc Renders a Molecule node
 */

import { useHasAccess } from 'labstep-web/components/Entity/Can/hooks';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { MoleculeCollapsibleCard } from 'labstep-web/components/Molecule/CollapsibleCard';
import { Molecule } from 'labstep-web/models/molecule.model';
import { Read } from 'labstep-web/prosemirror/components/NodeView/Read';
import { useReactNodeView } from 'labstep-web/prosemirror/components/ReactNodeView';
import React from 'react';
import type { MoleculeNodeProps } from './types';

export class MoleculeNode extends React.Component<MoleculeNodeProps> {
  shouldComponentUpdate() {
    return Boolean(!this);
  }

  render() {
    const { id, entity, canEdit, timestamp } = this.props;
    return (
      // prevent selection of inner text
      <div contentEditable={false}>
        <Read
          entityName={Molecule.entityName}
          timestamp={timestamp}
          id={id}
        >
          {({ entity: molecule }) => (
            <MoleculeCollapsibleCard
              molecule={molecule as Molecule}
              entity={entity}
              canEdit={canEdit}
            />
          )}
        </Read>
      </div>
    );
  }
}

export const MoleculeNodeView = ({ entity, timestamp }: any) => {
  const context = useReactNodeView();
  const { guid } = (context.node as any).attrs;

  const canEdit = useHasAccess(
    Molecule.entityName,
    guid,
    Action.edit,
  ) as boolean;

  return (
    <MoleculeNode
      id={guid}
      canEdit={canEdit}
      timestamp={timestamp}
      entity={entity}
    />
  );
};
